import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useDeleteProjectDocumentMutation } from "Projects/Api/Mutations/useDeleteProjectDocumentMutation";
import { useUploadProjectDocumentMutation } from "Projects/Api/Mutations/useUploadProjectDocumentMutation";
import { useProjectDocumentsQuery } from "Projects/Api/Queries/useProjectDocumentsQuery";
import { DocumentsSection } from "Shared/Documents/DocumentsSection";

interface ProjectDocumentsSectionProps {
  projectID: string;
  isEditable?: boolean;
}

export const ProjectDocumentsSection = ({
  projectID,
  isEditable = true,
}: ProjectDocumentsSectionProps): React.ReactNode => {
  const { t } = useResource();

  const { data, isLoading } = useProjectDocumentsQuery(projectID);
  const uploadMutation = useUploadProjectDocumentMutation(projectID);
  const deleteMutation = useDeleteProjectDocumentMutation(projectID);

  return (
    <DocumentsSection
      title={t(Resources.Documents.SectionTitle)}
      documents={data?.items}
      isLoading={isLoading}
      onUpload={(file, displayName) =>
        uploadMutation.mutateAsync({ file, displayName })
      }
      isUploading={uploadMutation.isPending}
      onDelete={deleteMutation.mutateAsync}
      isEditable={isEditable}
    />
  );
};
